module.exports = __webpack_public_path__ + "static/media/file-plus.0f33122b.svg";